<template>
  <b-modal id="bonus-otp-modal"
           :title="$t('code_for_bonus_payment')"
           size="sm"
           @show="onShow"
           @hide="onHide"
           hide-footer
           centered>
    <div v-if="sent === null">
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <div v-if="sent === true" class="mb-4">{{ $t('code_was_sent_to_patient_through_bot') }}</div>
    <div v-if="sent === false" class="alert alert-danger mb-4">{{ $t('code_was_not_sent') }}</div>
    <InputGroup v-if="sent === true" v-model="otp" :placeholder="$t('code')"/>
    <div v-if="checked && !isRight" class="alert alert-danger">{{ $t('wrong_code') }}</div>
  </b-modal>
</template>

<script setup>
import InputGroup from "@/components/form/InputGroup.vue"
import {computed, getCurrentInstance, onBeforeMount, ref, watch} from "vue"
import { TelegramService } from "@/services/api/telegram.api.service"
import {useStore} from "vuex"

const props = defineProps({
  bonus: Number
})

const emit = defineEmits(['checked'])
const store = useStore()

const patient = computed(() => store.state.patient.patient)
const superadmin = computed(() => store.state.auth.superadmin)
const loading = computed(() => store.state.dom.loading)

let bvModal = null
const isRight = ref(false)
const checked = ref(false)
const sent = ref(null)

const otp = ref('')

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
})

const onShow = () => {
  sent.value = null
  isRight.value = false
  otp.value = ''
  sendOTP()
}

const onHide = () => {
  emit('checked', isRight.value)
}

const sendOTP = async () => {
  const res = await TelegramService.sendOTP(superadmin.value, {
    userId: patient.value.id,
    bonus: Number(props.bonus)
  })
  sent.value = res.data
}

const checkOtp = async () => {
  if(loading.value) return
  const res = await TelegramService.checkOTP(superadmin.value, {
    userId: patient.value.id,
    code: otp.value
  })
  checked.value = true
  if(res.data) {
    isRight.value = true
    bvModal.hide('bonus-otp-modal')
  }
}

watch(otp, (val) => {
  checked.value = false
  if(val && val.length === 4) {
    checkOtp()
  }
}, { immediate: true })
</script>
